<template>
	<div class="column">
		<Header></Header>
		<div class="colunm_main_box">
			<el-breadcrumb
				class="column_top_nav"
				separator-class="el-icon-arrow-right"
				style="font-size:14px;"
			>
				<span style="float:left;">当前位置：</span>
				<el-breadcrumb-item :to="{ path: '/' }"
					>首页</el-breadcrumb-item
				>
				<el-breadcrumb-item
					v-for="(item, index) in location"
					:key="index"
				>
					<span v-if="index != location.length - 1">{{ item }}</span>
					<span v-if="index == location.length - 1" class="active">{{
						item
					}}</span>
				</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="column_center_box">
				<!-- 左侧导航 -->
				<div class="column_l_nav_box">
					<h5 class="column_l_nav_title">{{ topTitle }}</h5>
					<el-tree
						:data="navData"
						show-checkbox
						node-key="uid"
						:props="treeProps"
						:default-expand-all="true"
						@check="treeChange"
						ref="tree"
					>
					</el-tree>
					<img
						class="column_l_nav_img"
						src="../../assets/main/navbg.png"
						alt=""
					/>
				</div>
				<!-- 右侧显示部分 -->
				<div class="column_r_box">
					<Mode1
						:currentChoose="currentChoose"
						:treeString="treeString"
					></Mode1>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import magic from '@/../static/common/magic.js';
import $ from 'jquery';

import Header from '@/components/header';
import Footer from '@/components/footer';
import Mode1 from './modes'; //饼图+实现搜索+列表
import titlebg from '@/assets/main/titlebg.png';

export default {
	props: {},
	components: {
		Header,
		Footer,
		Mode1,
	},
	data() {
		return {
			navData: [], //导航栏数据
			navData2: [], //特殊的6个栏目多请求一个导航栏数据
			topTitle: '二级栏目', //左侧导航头部标题
			currentChoose: magic.getUrlKey('uid'), //当前选中的栏目uid
			currentModel: '', //当前调用的模板1-0/1-1/1-2:国际概览,2:默认,3:碳排放
			location: [], //获取位置数据
			urlName: magic.getUrlKey('name'), //获取url的参数name
			treeData: [],
			treeProps: {
				children: 'childrenList',
				label: 'title_name',
			},
			treeString: '',
		};
	},
	computed: {},
	created() {
		let _name = magic.getUrlKey('name'); //获取url的参数name
		_name ? (this.topTitle = _name) : (this.topTitle = '二级栏目');

		// let _uid = magic.getUrlKey('uid'); //获取url的参数uid
		// _uid ? (this.currentChoose = _uid) : '';
		// //console.log(this.urlName,'urlName');
	},
	mounted() {
		$('.column_l_nav_item .el-submenu__title').css({
			'font-size': '18px',
			color: '#8C8C8C',
		});
		setTimeout(() => {
			$('.column_l_nav_title').css(
				'background',
				"url('" + titlebg + "') no-repeat center"
			);
		}, 500);

		let _id = magic.getUrlKey('id'); //获取url的参数id
		_id ? this.fetchNavList(_id) : (widnow.location.href = '/index.html');

		let _name = magic.getUrlKey('name'); //获取url的参数name
		setTimeout(() => {
			//跳转传参跳转必传uid=A6062801&tagType=country&tagName=美国
			this.setQueryParams();
		}, 500); //$nextTick获取不到 延迟时间可以根据实际情况调整

		this.fetchLoaction(_id);
	},
	methods: {
		//获取导航数据
		fetchLoaction(_id) {
			let _this = this;
			api.getMenu(_id).then((res) => {
				_this.location = res.data.reverse();
			});
		},

		//获取导航数据
		fetchNavList(_id) {
			let _this = this;
			api.getNavList(_id).then((res) => {
				_this.navData = res.data;
			});
		},
		setQueryParams() {
			if (this.$route.query && this.$route.query.uid) {
				this.$refs.tree.setCheckedKeys([this.$route.query.uid]);
				this.treeChange();
			}
		},
		treeChange() {
			let treeData = this.$refs.tree.getCheckedKeys();
			this.treeString = treeData.join(',');
			//console.log(treeData);
		},
	},
};
</script>
<style scoped lang="less">
.column {
	width: 100%;
	/* height: 100vh; */
	background: #f2f2f2;
}
.colunm_main_box {
	width: 1300px;
	margin: 0 auto;
	min-height: 600px;
}
.column_top_nav {
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #1a1a1a;
	line-height: 26px;
	height: 54px;
	line-height: 54px;
}
.column_top_nav .active {
	color: #4eac41;
}
.column_center_box {
	width: 100%;
	overflow: hidden;
	margin-bottom: 50px;
}
// 左侧导航部分
.column_l_nav_box {
	float: left;
	width: 260px;
	// min-height: 460px;
	padding: 20px;
	background: #fff;
	border: 1px solid #e9e9e9;
	box-shadow: 0px 0px 6px 0px #eeeeee;
	position: relative;
	padding-bottom: 232px;
}
.column_l_nav_title {
	width: 260px;
	height: 50px;
	text-align: center;
	line-height: 50px;
	font-size: 18px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #f7f7f7;
	background: url('../../assets/main/titlebg.png') no-repeat center;
	background-size: cover;
	margin-bottom: 20px;
}
.column_l_nav_title2 {
	width: 260px;
	height: 50px;
	line-height: 50px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #439238;
	margin-bottom: 10px;
	margin-top: 10px;
	border-bottom: 1px solid #439238;
	font-size: 16px;
	text-align: center;
}
.column_l_nav_item {
	background: #f2f2f2;
	margin-bottom: 8px;
	font-size: 15px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #3f433f;
}
.column_l_nav_img {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
}
.column_l_nav_style1 {
	font-size: 15px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	// color: #3F433F;
}
.column_l_nav_style2 {
	border-bottom: 1px solid #f3f3f3;
	font-size: 18px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #8c8c8c;
}
.column_l_nav_style3 {
	font-size: 13px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #808080;
}
.column_l_nav_style3:hover {
	color: #4eac41;
}

// 右侧显示部分
.column_r_box {
	float: right;
	width: 950px;
	// padding:14px 30px;
	min-height: 578px;
	// background: #FFFFFF;
	border: 1px solid #e9e9e9;
	box-shadow: 0px 0px 6px 0px #eeeeee;
}
.el-checkbox {
	color: rgba(106, 104, 104, 1) !important;
	font-size: 14px;
	// padding: 5px 0;
	line-height: 39px;
}
/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
	color: #4eac41 !important;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
	background-color: #4eac41 !important;
	border-color: #4eac41 !important;
}
/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
	background-color: #4eac41 !important;
	border-color: #4eac41 !important;
}
// /deep/ .el-tree-node__content {
// 	background: #f2f2f2;
// 	margin-bottom: 8px;
// 	font-size: 15px;
// 	font-family: Source Han Sans CN;
// 	font-weight: 700;
// 	color: #3f433f;
// }
// /deep/ .el-tree > .el-tree-node > .el-tree-node__content {
// 	background: red;
// }

// /deep/ .el-tree > .el-tree-node:focus > .el-tree-node__content {
// 	background: red;
// }
</style>



// WEBPACK FOOTER //
// src/view/dynamicInfo/index.vue